export default class GeoJsonObject {
  /**
   * @returns {String} The static ID set on the class.
   */
  getId() {
    return this.constructor.id;
  }
}
